// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedOctRotationX_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0V24H13.3389L14.6305 22H2V2H22V13.4316H24V0H0ZM5.02441 11.4078C5.21315 9.20477 6.43995 7.12641 8.5 5.93704C11.848 4.00404 16.1292 5.15117 18.0622 8.49922L18.9282 7.99922L18.6962 11.5973L15.4641 9.99922L16.3301 9.49922C14.9494 7.10775 11.8915 6.28838 9.5 7.66909C8.52501 8.232 7.81132 9.0737 7.4015 10.0354L5.02441 11.4078ZM15.2792 18.1837C11.9659 19.9432 7.82857 18.7741 5.93782 15.4992L5.0718 15.9992L5.30385 12.4011L8.5359 13.9992L7.66987 14.4992C8.99209 16.7894 11.8524 17.6378 14.1926 16.493L15.2792 18.1837ZM16.8977 17.0028L15.888 15.4316H18.1019H18.156L19.872 18.3116L21.528 15.4316H23.796L21.108 19.7396L24 23.9996H21.648L19.812 21.0236L17.976 23.9996H15.72L18.564 19.5956L16.8977 17.0028Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedOctRotationX is a generated icon component.
 */
let IconMedOctRotationX = IconMedOctRotationX_1 = class IconMedOctRotationX extends IconBaseElement {
    render() {
        return html `${IconMedOctRotationX_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedOctRotationX.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedOctRotationX = IconMedOctRotationX_1 = __decorate([
    customElement('zui-icon-med-oct-rotation-x')
], IconMedOctRotationX);
export { IconMedOctRotationX };
